<ng-template cxOutlet="cx-storefront">
  <ng-template cxOutlet="cx-header">
    @if (!hideHeader && !isModal) {
      @if (mastHeadEnabled) {
        <udex-masthead-shell
          id="masthead-shell"
          home-url="https://www.sap.com"
          logo-title="SAP"
          site-label-aria-label="SAP Store"
          homepage-aria-label="SAP Homepage"
          close-button-accessible-name="Close Search"
          logo-alt="SAP Logo"
          logo-url="https://cdn.udex.services.sap.com/dds/design-tokens/assets/logos/sap-logo.svg"
          site-label-url="https://store.sap.com/"
          body-overflow
        >

          <!-- items on the left -->
          @for (link of mainLinks; track $index) {
            <udex-masthead-item
              accessible-name="link.title">
              {{link.title}}
              <udex-masthead-menu
                slot="dropdown"
                [attr.sub-items]='mastHeadNavigationService.transformSubMenus(link.subMenuRows)'
              >
              </udex-masthead-menu>
            </udex-masthead-item>
          }

          <!-- items on the right -->
          @if (!hideExploreSapLink) {
            <udex-masthead-item
              accessible-name="Explore SAP"
              slot="exploreSAP">
              {{exploreSapLink.title}}
              <udex-masthead-menu
                [attr.menu-title]='exploreSapLink.displayTitle'
                slot="dropdown"
                [attr.sub-items]='mastHeadNavigationService.transformSubMenus(exploreSapLink.subMenuRows)'
              >
              </udex-masthead-menu>
            </udex-masthead-item>
          }

          <udex-search
            id="search"
            label="Search"
            value
            language-voice="en-US"
            mode="Home Search"
            show-suggested-popover
            show-submit-button
            suggestion-list='{"suggested":{"label":"Suggested searches","list":["hana","SAP hana","SAP hana Enterprise Cloud","SAP hana Training"]},"recommended":{"label":"Recommended pages","list":["What is SAP hana","SAP hana in Community"]}}'
            slot="search">
          </udex-search>

          <udex-masthead-item
            href="https://www.sap.com/about/trust-center.html"
            icon="cart"
            accessible-name="cart"
            slot="cart">
          </udex-masthead-item>
          <udex-masthead-item slot="profile" icon="person-placeholder">
            <!--            TODO: Add udex-avatar and udex-masthead-profile-menu for logged-in user, in scope of DCP-41495 and DCP-40996 -->
            <!--            <udex-avatar-->
            <!--              color-scheme="Transparent"-->
            <!--              icon="person-placeholder"-->
            <!--              shape="Circle"-->
            <!--              size="S"-->
            <!--              initials="profile"-->
            <!--              accessible-name="profile"-->
            <!--              interactive-->
            <!--            ></udex-avatar>-->
            <!--            <udex-masthead-profile-menu-->
            <!--              id="profile-menu"-->
            <!--              slot="dropdown"-->
            <!--              links='[{"category":"Group heading1","items":[{"title":"Lorem ipsum","url":"https://sap.com","externalLink":true},{"title":"Curabitur aliquam","url":"https://sap.com","badge":"72"},{"title":"Sed sodales nisisuscipit","url":"https://sap.com"},{"title":"Lorem ipsum dolor an example two lines","url":"https://sap.com","externalLink":true,"badge":"73"},{"title":"Lorem ipsum dolor sit anconsectetur","url":"https://sap.com","externalLink":true,"badge":"37"}]},{"category":"Group heading2","items":[{"title":"Manage my account","url":"http://sap.com/myaccount"},{"title":"SAP Learning Journeys","url":"https://sap.com","externalLink":true},{"title":"Training Courses","url":"https://sap.com"},{"title":"SAP Learning Hub","url":"https://sap.com","badge":"72","externalLink":true},{"title":"SAP Training and Adoption","url":"https://sap.com","badge":"31"}]}]'-->
            <!--              logged-in-user='{"name":"Damian Smith","username":"damian.smith","email":"damian.smith@sap.com","avatarInitials":"JS","avatarUrl":"./stories/list/image.png"}'>-->
            <!--              <udex-message-strip design="Action" slot="message">-->
            <!--                <span>Information message.</span>-->
            <!--                <udex-link href="https://www.sap.com" target="_blank">Learn more</udex-link>-->
            <!--              </udex-message-strip>-->
            <!--            </udex-masthead-profile-menu>-->
          </udex-masthead-item>

          <udex-masthead-mobile-menu id="mobile-menu" slot="mobileMenu">
            <udex-search
              slot="search"
              id="mobile-search"
              label="Search"
              value
              language-voice="en-US"
              mode="Home Search"
              show-suggested-popover
              show-submit-button>
            </udex-search>
            @for (link of mainLinks; track $index) {
              <udex-masthead-item
                accessible-name="link.title"
                [attr.sub-items]='mastHeadNavigationService.transformSubMenus(link.subMenuRows)'>
                {{link.title}}
              </udex-masthead-item>
            }
            @if (!hideExploreSapLink) {
              <udex-masthead-item
                accessible-name="Explore SAP"
                slot="exploreSapMobileButton"
                [attr.sub-items]='mastHeadNavigationService.transformSubMenus(exploreSapLink.subMenuRows)'
              >
                {{exploreSapLink.title}}
              </udex-masthead-item>
            }
          </udex-masthead-mobile-menu>
        </udex-masthead-shell>
      }

      <!--      When removing ds-contextual-navigation, please make sure to also remove dcp-contextual-navigation.service.ts ! -->
      @if (contextualNavigationEnabled) {
        <div class="navigation-placeholder"></div>
        <ds-contextual-navigation
          [mainLinks]=contextualNavigationService.mainLinks
          [exploreSapLink]=contextualNavigationService.exploreSapLink
          [shoppingCartConfig]="shoppingCartConfig$ | async"
          [landingZone]=contextualNavigationService.landingZone
          [profile]="contextualUserMenuConfig$ | async"
          [searchConfig]="contextualSearchConfig"
          [countrySelectorConfig]=contextualNavigationService.countrySelectorConfig
          [loggedInUser]=contextualNavigationService.loggedInUser
          mode="light"
          avatar-source-url="https://avatars.profile.sap.com/images"
          [hideExploreSapLink]=contextualNavigationService.hideExploreSapLink
          [notifications]=contextualNavigationService.notifications
          (countrySelected)="onCountrySelected($event?.detail?.detail?.countryCode)"
          [translations]=contextualNavigationService.translations
          [homeLogoUrl]=contextualNavigationService.homeLogoUrl
          (login)="onLogin()"
          (logout)="onLogout()"
          (focus)="skipToContent($event)"
        ></ds-contextual-navigation>
      }
    }
    @if (!hideHeader && isModal) {
      <header
        (click)="collapseMenuIfClickOutside($event)"
        (keydown.escape)="collapseMenu()"
        [class.is-expanded]="isExpanded$ | async"
      >
        <cx-page-layout section="header"></cx-page-layout>
        <cx-page-layout section="navigation"></cx-page-layout>
      </header>
    }
    @if (!hideHeader && !isModal) {
      <cx-page-layout section="navigation"></cx-page-layout>
    }
    <dcp-global-message></dcp-global-message>
  </ng-template>
  <router-outlet></router-outlet>

  <ng-template cxOutlet="cx-footer">
    @if (!isModal) {
      <div class="spacer"></div>
    }
    <dcp-footer-container></dcp-footer-container>
  </ng-template>
  <dcp-country-switch-modal
    #countrySwitchModalComponent
    [countries]="countries"
  ></dcp-country-switch-modal>
  @if (showSapChatAdvisor()) {
    <dcp-chat-advisor/>
  }
</ng-template>
